const css = `.compact-type-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}
.compact-type-item i {
  font-size: var(--font-size-base);
  color: var(--text-color-secondary);
}
.compact-type-item .compact-type-name {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
}

.adaptive-select-option .compact-type-item {
  padding: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvQ29tcGFjdFJlc2VydmF0aW9uVHlwZVNlbGVjdCIsInNvdXJjZXMiOlsiQ29tcGFjdFJlc2VydmF0aW9uVHlwZVNlbGVjdC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTs7O0FBS0Y7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi5jb21wYWN0LXR5cGUtaXRlbSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdhcDogOHB4O1xuICBwYWRkaW5nOiA0cHggMDtcblxuICBpIHtcbiAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1iYXNlKTtcbiAgICBjb2xvcjogdmFyKC0tdGV4dC1jb2xvci1zZWNvbmRhcnkpO1xuICB9XG5cbiAgLmNvbXBhY3QtdHlwZS1uYW1lIHtcbiAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1iYXNlKTtcbiAgICBmb250LXdlaWdodDogdmFyKC0tZm9udC13ZWlnaHQtbWVkaXVtKTtcbiAgfVxufVxuXG4uYWRhcHRpdmUtc2VsZWN0LW9wdGlvbiB7XG4gIC5jb21wYWN0LXR5cGUtaXRlbSB7XG4gICAgcGFkZGluZzogMDtcbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
